import { api } from './client';
import type { DuplicateGroup, Env } from '../types';

export function fetchDuplicateGroup(deviceId: number, env: Env) {
  return api<DuplicateGroup>(`/duplicates/${deviceId}?env=${env}`);
}

export function archiveDevice(deviceId: number, env: Env, reason: string) {
  return api<null>(`/duplicates/${deviceId}/archive?env=${env}`, {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}
